import FromNow from './FromNow';

export { default as useFromNow } from './useFromNow';
export default FromNow;
